import axios from "axios";
import Config from "../utils/Config";

class AccountPayableService{
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };
    
      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

      //get account payable search data
      async GetAccountPayableSearchData(
        accessToken,
        groupId,
        companyId,
        onRow,
        onMeta,
        onDone,
        fromDate = null,
        toDate = null
      ) {
        let url = `${Config.BACKEND_URL}/api/docMogu/invoicesAndExtractedData?companyId=${companyId}&documentType=Accounts payable`;
        if (fromDate && toDate) {
          url += `&fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`;
        }
        
        const response = await fetch(
          url,
          {
            headers: {
              Authorization: accessToken,
              GroupId: groupId,
              CompanyId: companyId,
            },
          }
        );
      
        if (!response.body) {
          throw new Error("Streaming not supported");
        }
      
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
      
        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
      
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split("\n");
          buffer = lines.pop(); // keep incomplete line
      
          for (const line of lines) {
            if (!line.trim()) continue;
      
            const message = JSON.parse(line);
      
            if (message.type === "meta" && onMeta) {
              onMeta(message.total);
            }
      
            if (message.type === "row" && onRow) {
              onRow(message.data);
            }
      
            if (message.type === "done" && onDone) {
              onDone();
            }
          }
        }
      }

      async GetDocumentTypes (accessToken, groupId, companyId)
      {
        //console.log("in Account Payable API");
        this.setAccessToken(accessToken,groupId,companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/data/e-invoice-types`, //Payble has no data thats (change this to payable later)?
          this.config
      )
       //console.log("Return Data "+ data.data);
      return data.data;

      }

      async GetDocumentClassification (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken,groupId,companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/data/classification-codes`, //Payble has no data thats (change this to payable later)?
          this.config
      )
      return data.data;

      }

      async GetDocumentClassificationForAP (accessToken, groupId, companyId)
      {
        this.setAccessToken(accessToken,groupId,companyId);
        const data = await axios.get(
          Config.BACKEND_URL + `/api/docMogu/classificationCodesForAP`, 
          this.config
      )
      return data.data;

      }

      

      async GetCurrancyTypes (accessToken)
      {
        this.setAccessToken(accessToken,"","");
        const data = await axios.get(
          Config.BACKEND_URL +`/api/data/currency-codes`,
          this.config
        )
        //console.log("Curruncy APi Call");
        //console.log(JSON.stringify(data.data));
        return data.data;
      }
      async GetTaxTypes (accessToken)
      {
        this.setAccessToken(accessToken,"","");
        const data = await axios.get(
          Config.BACKEND_URL +`/api/data/tax-types`,
          this.config
        )
        return data.data;
      }
      async GetIncoTerms (accessToken)
      {
        this.setAccessToken(accessToken,"","");
        const data = await axios.get(
          Config.BACKEND_URL +`/api/data/incoterms`,
          this.config
        )
        return data.data;
      }

      async GetInvoiceDetails (accessToken, groupId, companyId, formData){
        this.setAccessToken(accessToken, groupId, companyId);
    
        const data = await axios.post(
            Config.BACKEND_URL + "/api/docMogu/invoceInformation", //api/company
            formData,
            this.config
          )
          return data.data;
      }

      async InvoiceSubmition (accessToken,groupId, companyId, formData)
      {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.post(
          Config.BACKEND_URL + "/api/docMogu/invoiceSubmission", //api/company
          formData,
          this.config
        )
        return data.data;
      }

      async NotifyErrorAdminViaEmail (accessToken,groupId, companyId, formData)
      {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.post(
          Config.BACKEND_URL + "/api/docMogu/notify-admin", //api/company
          formData,
          this.config
        )
        return data.data;
      }
}

export default new AccountPayableService();